export default __webpack_public_path__ + "static/c1430353d2ce588443bb3b1f20cb2658.png";